import { render, staticRenderFns } from "./EditUnits.vue?vue&type=template&id=6ba90d82&scoped=true&"
import script from "./EditUnits.vue?vue&type=script&lang=ts&"
export * from "./EditUnits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba90d82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/app-root/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ba90d82')) {
      api.createRecord('6ba90d82', component.options)
    } else {
      api.reload('6ba90d82', component.options)
    }
    module.hot.accept("./EditUnits.vue?vue&type=template&id=6ba90d82&scoped=true&", function () {
      api.rerender('6ba90d82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/GPortal/Frontend/vue/component/modal/gamecloud/EditUnits.vue"
export default component.exports